import { createSlice } from "@reduxjs/toolkit";
import { checkFilterSelection } from "utils/consumerFilterUtils";

const initialState = {
    correlationAnalysisResult: [],
    correlationAnalysisSampleInfo: [],
    isCorrelationAnalysisResultLoading: true,
    currentSelectedFiltersForCorrelation: {},
    currentSelectedAllFiltersForCorrelation: {},
    missingFiltersForCorrelation: {},
    isFilterAcrossProductsForCorrelation: false,
    weightToggleForCorrelation: false,
    disableWeightToggleForCorrelation: true,
    filterSelectionStatus: false,
    selectedCorrelationMethod: {},
};

export const correlationStore = createSlice({
    name: "correlationStore",
    initialState,
    reducers: {
        loadCorrelationAnalysisResultState: (state, action) => {
            state.correlationAnalysisResult = action.payload;
        },
        loadCorrelationAnalysisSampleInfoState: (state, action) => {
            state.correlationAnalysisSampleInfo = action.payload;
        },
        loadIsCorrelationAnalysisResultLoadingState: (state, action) => {
            state.isCorrelationAnalysisResultLoading = action.payload;
        },
        loadCurrentSelectedFiltersForCorrelationState: (state, action) => {
            state.currentSelectedFiltersForCorrelation = action.payload;
            state.filterSelectionStatus = checkFilterSelection(action.payload);
        },
        loadCurrentSelectedAllFiltersForCorrelationState: (state, action) => {
            state.currentSelectedAllFiltersForCorrelation = action.payload;
        },
        loadMissingFiltersForCorrelationState: (state, action) => {
            state.missingFiltersForCorrelation = action.payload;
        },
        loadIsFilterAcrossProductsForCorrelationState: (state, action) => {
            state.isFilterAcrossProductsForCorrelation = action.payload;
        },
        loadWeightToggleForCorrelationState: (state, action) => {
            state.weightToggleForCorrelation = action.payload;
        },
        loadDisableWeightToggleForCorrelationState: (state, action) => {
            state.disableWeightToggleForCorrelation = action.payload;
        },
        loadSelectedCorrelationMethodState: (state, action) => {
            state.selectedCorrelationMethod = action.payload;
        },
        resetCorrelationStore: () => initialState,
    },
});
export const {
    loadCorrelationAnalysisResultState,
    loadCorrelationAnalysisSampleInfoState,
    loadIsCorrelationAnalysisResultLoadingState,
    loadCurrentSelectedFiltersForCorrelationState,
    loadCurrentSelectedAllFiltersForCorrelationState,
    loadMissingFiltersForCorrelationState,
    loadIsFilterAcrossProductsForCorrelationState,
    loadWeightToggleForCorrelationState,
    loadDisableWeightToggleForCorrelationState,
    resetCorrelationStore,
    loadSelectedCorrelationMethodState,
} = correlationStore.actions;

export default correlationStore.reducer;
